const redirectToCanvasActionName = "goToCanvas";

export { redirectToCanvasActionName };
